import React from 'react'
import { BaseCard } from './BaseCard'
import { Select } from '@/components'
import { APIClient } from '@/services'
import { RenderItemProps } from '../types'
import { useProfilePrompt } from '../../useProfilePrompt'

export const SeniorityCard = ({ item }: RenderItemProps) => {
  const { data: options } = APIClient.Session.useProfileOptions()

  const prompt = useProfilePrompt(item)

  return (
    <BaseCard prompt={prompt}>
      <Select
        label='Seniority'
        options={options?.seniority ?? []}
        {...prompt.form.register('seniority')}
        arrowIconName='chevron-right'
        placeholder='Select one'
        variants={['noError', 'prompt']}
        onMenuOpen={() => BaseCard.setOpenPortal(prompt, true)}
        onMenuClose={() => BaseCard.setOpenPortal(prompt, false)}
      />
    </BaseCard>
  )
}
